import React from "react";
import { MapPin } from "lucide-react";
import SettingsListPanel from "./SettingsListPanel";

// The timezone here is what the missing-time-log reminder uses to work out when
// it is 8am for everyone at this location, so every location must carry one
// rather than silently falling back to the org default.
const WorkLocationsManagement = () => (
  <SettingsListPanel
    config={{
      title: "Work Locations",
      subtitle: "Manage employee work locations",
      icon: MapPin,
      endpoint: "/api/settings/work-locations",
      itemLabel: "Work Location",
      columnLabel: "Name",
      placeholder: "Enter work location name",
      extraField: {
        key: "timezone",
        label: "Timezone",
        type: "countryTimezone",
        required: true,
        hint: "Reminders for people at this location are timed against this timezone.",
        width: 200,
      },
    }}
  />
);

export default WorkLocationsManagement;
